// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1Csdc","consentsList":"PatientConsents_consentsList__2yunb","consentsListEmpty":"PatientConsents_consentsListEmpty__1euRA"};